import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const SettingsCtx = createContext(null);

const DEFAULTS = {
  business_name: "GTA Wholesale Supply",
  public_email: "",
  phone: "",
  address: "",
  hours: "",
  homepage_headline: "Your Trusted Convenience Wholesale Partner",
  homepage_subheadline: "",
  homepage_hero_image: "",
  announcements: [],
  marquee_speed: 40,
  delivery_info: "",
  free_delivery_amount: 500,
  currency: "$",
  footer_text: "",
  facebook_url: "", instagram_url: "", linkedin_url: "",
  show_phone: true, show_email: true,
  whatsapp_enabled: false, whatsapp_number: "",
  enquiry_form_enabled: true,
  retailer_login_enabled: true,
  ordering_enabled: false,
};

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);
  const [loaded, setLoaded] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get(`/settings/public?_t=${Date.now()}`);
      setSettings({ ...DEFAULTS, ...data });
    } catch {}
    finally { setLoaded(true); }
  }, []);

  useEffect(() => {
    refresh();
    const onFocus = () => refresh();
    const onVisible = () => { if (document.visibilityState === "visible") refresh(); };
    window.addEventListener("focus", onFocus);
    document.addEventListener("visibilitychange", onVisible);
    return () => {
      window.removeEventListener("focus", onFocus);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, [refresh]);

  return (
    <SettingsCtx.Provider value={{ settings, loaded, refresh }}>
      {children}
    </SettingsCtx.Provider>
  );
}

export const useSettings = () => useContext(SettingsCtx);
